<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Staff Grades</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-staff-grade v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <staff-grades-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import StaffGradesTable from '@/components/staffgrade/Table/index'
import AddStaffGrade from '@/components/staffgrade/Forms/Add/index'

export default {
  components: {
    StaffGradesTable,
    AddStaffGrade,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('staff-grade', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getStaffGrades()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getStaffGrades: function() {
      this.loading = true
      this.$http.get('/api/staff_grade', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getStaffGrades()
    },
    handleUpdateTable: function() {
      this.getStaffGrades()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStaffGrades()
    },
    onChange(current) {
      this.current = current
      this.getStaffGrades()
    },
  },
}
</script>
<style>
  .error { padding: 25px 5px; }
</style>
